export default __webpack_public_path__ + "static/media/spin-bg-0.9d2b69bf.png";